import {
  FaJava, FaHtml5, FaCss3Alt, FaCode, FaReact, FaPhp,
} from 'react-icons/fa';
import {
  SiDart, SiFlutter, SiJavascript, SiMysql,SiAndroidstudio,
  SiNextdotjs, SiTypescript, SiPostgresql, SiWoocommerce,
} from 'react-icons/si';

const projects = [
  {
    title: "Alfayed",
    description: "The full digital platform for a bespoke tailoring house: a Next.js storefront over a headless commerce backend with incremental static regeneration and webhook-driven cache invalidation, a product catalogue, and a spam-resistant enquiry pipeline. Migrated the live domain from a legacy WordPress site with zero downtime.",
    live: "https://alfayed.us",
    tech: [
      { name: "Next.js", icon: SiNextdotjs, color: "bg-[#111827]" },
      { name: "React", icon: FaReact, color: "bg-[#1f2937]" },
      { name: "TypeScript", icon: SiTypescript, color: "bg-[#3b82f6]" },
      { name: "WooCommerce", icon: SiWoocommerce, color: "bg-[#7f54b3]" },
    ]
  },
  {
    title: "Alfayed Retail and Production Management System",
    description: "A bilingual English and Arabic retail and production management system built end to end: a React and TypeScript front end with full right-to-left support, a PHP API, and a PostgreSQL schema built on append-only stock and customer ledgers. Point of sale with barcode scanning, thermal receipt and label printing, idempotent transaction handling that survives connection loss without double-charging, authentication hardening, and returns, invoicing and reporting.",
    live: "https://manage.alfayed.us",
    tech: [
      { name: "React", icon: FaReact, color: "bg-[#1f2937]" },
      { name: "TypeScript", icon: SiTypescript, color: "bg-[#3b82f6]" },
      { name: "PHP", icon: FaPhp, color: "bg-[#6b7280]" },
      { name: "PostgreSQL", icon: SiPostgresql, color: "bg-[#336791]" },
    ]
  },
  {
    title: "Life Calculator",
    description: "An Android app for calculating BMI, age, discounts, and unit conversions. Built with Flutter and Dart, following Agile principles and Material Design.",
    github: "https://github.com/3lifayed/LifeCalculator",
    live: "#",
    images: [
      "/images/life1.jpg",
      "/images/life2.jpg",
    ],
    tech: [
      { name: "Dart", icon: SiDart, color: "bg-[#38bdf8]" },
      { name: "Flutter", icon: SiFlutter, color: "bg-[#02569B]" },
      { name: "Android Studio", icon: SiAndroidstudio, color: "bg-[#10b981]" },
    ]
  },
  {
    title: "Text to Voice",
    description: "A Java desktop tool that converts text into speech using third-party libraries. Developed in NetBeans for Windows users.",
    github: "https://github.com/3lifayed/TextToVoice-Java",
    live: "#",
    images: [
      "/images/text1.png"
    ],
    tech: [
      { name: "Java", icon: FaJava, color: "bg-[#f97316]" }
    ]
  },
  {
    title: "Media Player",
    description: "An Android multimedia player app built using Java, designed for a human-computer interaction project with video/audio features.",
    github: "https://github.com/3lifayed/MediaPlayer",
    live: "#",
    images: [
      "/images/media1.jpg",
      "/images/media2.jpg",
    ],
    tech: [
      { name: "Java", icon: FaJava, color: "bg-[#f97316]" },
      { name: "Android Studio", icon: SiAndroidstudio, color: "bg-[#10b981]" },
    ]
  },
  {
    title: "Library Management",
    description: "A C# desktop app for library book inventory, built with SQL Server and Visual Studio. Implemented ERD and database schema with team collaboration.",
    github: "https://github.com/3lifayed/Library",
    live: "#",
    images: [
      "/images/library1.png",
      "/images/library2.png",
    ],
    tech: [
      { name: "C#", icon: FaCode, color: "bg-[#6b7280]" },
      { name: "MySQL", icon: SiMysql, color: "bg-[#64748b]" }
    ]
  },
  {
    title: "Suity",
    description: "An inventory management system for a suit store. Built with C# and SQL, following software engineering principles and debugging practices.",
    github: "https://github.com/3lifayed/Suity",
    live: "#",
    images: [
      "/images/suity1.png",
    ],
    tech: [
      { name: "C#", icon: FaCode, color: "bg-[#6b7280]" },
      { name: "MySQL", icon: SiMysql, color: "bg-[#64748b]" }
    ]
  },
  {
    title: "Explore Egypt",
    description: "A web app highlighting Egyptian attractions, designed with HTML, CSS, and JavaScript. Focused on user experience and created wireframes in Adobe XD.",
    github: "https://github.com/3lifayed/ExploreEgypt",
    live: "#",
    images: [
      "/images/egypt1.png",
      "/images/egypt2.png",
      "/images/egypt3.png",
    ],
    tech: [
      { name: "HTML", icon: FaHtml5, color: "bg-[#f97316]" },
      { name: "CSS", icon: FaCss3Alt, color: "bg-[#0ea5e9]" },
      { name: "JavaScript", icon: SiJavascript, color: "bg-[#facc15]" }
    ]
  }
];

export default projects;
